import Vue from 'vue'

var authState = {
    user: null,
    googleClientId: null,
}

var authGetters = {
    isAuthenticated: (state) => {
        return state.user !== null
    },
    getUser: (state) => {
        return state.user
    },
    getAuthenticationHeader: () => {
        let token = localStorage.getItem('id_token')
        return token
    }
}

var authMutations = {
    SET_USER (state, user) {
        state.user = {
            name: user.name,
            email: user.email
        }
    },
    CLEAR_USER (state) {
        state.user = null
    },
    SET_GOOGLE_CLIENT_ID (state, googleClientId) {
        state.googleClientId = googleClientId
    },
}

var authActions = {
    isTokenValid: ({ commit }) => {
        let expiresAt = localStorage.getItem('expires_at')
        let currentTime = new Date()

        if (expiresAt < currentTime.getTime() / 1000) {
            localStorage.removeItem('id_token')
            localStorage.removeItem('expires_at')
            commit('CLEAR_USER')
        }
    },
    getUser: ({ commit }, token) => {
        return new Promise((resolve, reject) => {
            Vue.http.post('me', { token: token }).then(function (response) {
                commit('SET_USER', response.body)
                localStorage.setItem('id_token', token)
                localStorage.setItem('expires_at', response.body.expiresAt)
                resolve()
            }).catch(function (response) {
                localStorage.removeItem('id_token')
                reject(response.bodyText)
            })
        })
    },
    login: ({ state }) => {
        return new Promise((resolve, reject) => {
            google.accounts.id.initialize({
                client_id: state.googleClientId,
                callback: (response) => {
                    resolve(response.credential)
                },
                hosted_domain: 'celtra.com',
                ux_mode: 'popup',
            })
            google.accounts.id.prompt((notification) => {
                if (notification.isSkippedMoment()) {
                    // Handle cases where the sign-in was not possible or was skipped
                    reject(new Error('Login failed'))
                }
            })
        })
    },
    logout: ({ commit }) => {
        commit('CLEAR_USER')
        localStorage.removeItem('id_token')
        localStorage.removeItem('expires_at')
    },
    loadGoogleClientId: ({ commit }) => {
        Vue.http.get('auth/details').then((response) => {
            commit('SET_GOOGLE_CLIENT_ID', response.body.googleClientId)
        }).catch((response) => {
            console.error(error)
        })
    },
}

export {
    authState,
    authGetters,
    authMutations,
    authActions
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js